<template>
  <div>
    <div class="form-group row mb-2">
      <label class="col-sm-4 lh30 text-lr">
        <i v-if=" Data.data.c_priority==='S'" class="fa fa-asterisk text-danger font10 ml-1"
           aria-hidden="true"></i>{{ Data.data.c_name }}：</label>
      <div class="col-sm-7 ">
        <el-input-number v-model="value" @change="$get_function(Data,value)" :min="Data.data.c_data_type==='Numf'?-Infinity:0"
                         size="small" label="描述文字"></el-input-number>
        {{ Data.data.c_unit }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "input-number",
  props: [
    'Data'
  ],
  data() {
    return {
      value: this.Data.data.c_value,
    }
  },
  created() {
  },
  watch: {},
  methods: {}


}
</script>

<style scoped>

</style>
